import React, {useRef, useEffect} from 'react';
import { Link } from 'gatsby';
import l1logo from "../assets/img/L1A_logo2.png";
import interimLogo from "../assets/img/lia-Intraprise-interim-logo.png";


const Topnav = (props) => {

    const headerRef = useRef();
    const navBarRef = useRef();
    const mobileNavToggleRef = useRef();

    useEffect(() => {

        let selectHeader = headerRef.current;

        const on = (type, el, listener, all = false) => {
            let selectEl = select(el, all)
            if (selectEl) {
              if (all) {
                selectEl.forEach(e => e.addEventListener(type, listener))
              } else {
                selectEl.addEventListener(type, listener)
              }
            }
        }

        const select = (el, all = false) => {
            el = el?.trim()
            if (all) {
              return [...document.querySelectorAll(el)]
            } else {
              return document.querySelector(el)
            }
        }

        const onscroll = (el, listener) => {
            el.addEventListener('scroll', listener)
        }


        /**
         * Navbar links active state on scroll
        */
        let navbarlinks = select('#navbar .scrollto', true)
        const navbarlinksActive = () => {
            let position = window.scrollY + 200
            navbarlinks.forEach(navbarlink => {
            if (!navbarlink.hash) return
            let section = select(navbarlink.hash)
            if (!section) return
            if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {
                navbarlink.classList.add('active')
            } else {
                navbarlink.classList.remove('active')
            }
            })
        }
        window.addEventListener('load', navbarlinksActive)
        onscroll(document, navbarlinksActive)

        const scrollto = (el) => {
            let offset = selectHeader.offsetHeight
        
            if (!selectHeader.classList.contains('header-scrolled')) {
              offset -= 16
            }
        
            let elementPos = select(el).offsetTop
            window.scrollTo({
              top: elementPos - offset,
              behavior: 'smooth'
            })
        }

        
        if (selectHeader) {
          let headerOffset = selectHeader.offsetTop
          let nextElement = selectHeader.nextElementSibling
          const headerFixed = () => {
            if ((headerOffset - window.scrollY) <= 0) {
              selectHeader.classList.add('fixed-top')
              nextElement.classList.add('scrolled-offset')
            } else {
              selectHeader.classList.remove('fixed-top')
              nextElement.classList.remove('scrolled-offset')
            }
          }
          window.addEventListener('load', headerFixed)
          onscroll(document, headerFixed)
        }

        /**
         * Mobile nav toggle
         */
        on('click', '.mobile-nav-toggle', function(e) {
            select('#navbar').classList.toggle('navbar-mobile')
            this.classList.toggle('bi-list')
            this.classList.toggle('bi-x')
        })

        /**
         * Mobile nav dropdowns activate
         */
        on('click', '.navbar .dropdown > a', function(e) {
            if (select('#navbar').classList.contains('navbar-mobile')) {
            e.preventDefault()
            this.nextElementSibling.classList.toggle('dropdown-active')
            }
        }, true)


        /**
         * Scroll with offset on links with a class name .scrollto
         */
        on('click', '.scrollto', function(e) {
            if (select(this.hash)) {
            e.preventDefault()

            let navbar = select('#navbar')
            if (navbar.classList.contains('navbar-mobile')) {
                
                navbar.classList.remove('navbar-mobile')
                let navbarToggle = select('.mobile-nav-toggle')
                navbarToggle.classList.toggle('bi-list')
                navbarToggle.classList.toggle('bi-x')
            }
            scrollto(this.hash)
            }
        }, true)

      // Collapse responsive navbar when toggler is visible
      const navbarToggler = document.body.querySelector('.dropdown-toggle');
      const responsiveNavItems = [].slice.call(
          document.querySelectorAll('#navbar .nav-link:not(.dropdown-toggle), #navbar .dropdown-item, h1.logo a, .dropdown-navitem')
      );
      responsiveNavItems.map(function (responsiveNavItem) {
          if (window.location.pathname !== "/") {
              if (responsiveNavItem?.hash?.indexOf('#') === 0) {
                   // this to an absolute link (pointing to the correct section on the hompage)
                   responsiveNavItem.href = "/" + responsiveNavItem.hash;
              }
          }
          responsiveNavItem.addEventListener('click', () => {
            if (navbarToggler) {
                if (window.getComputedStyle(navbarToggler).display !== 'none') {
                    navbarToggler.click();
                }
            }
        });
  
      });


    }, []);

    return (
        <>
            <a name="home"></a>
                {/* BEGIN BANNER */}
                <div className="container-fluid p-2 press-banner clearfix">
                    <div className="container">
                        <div className="d-flex align-items-center">
                            <p className="text-white text-center text-small">We are excited to announce that we have joined forces with Intraprise.  As a new combined organization, we have the opportunity to transform the current Level1Analytics product to the most capable and scalable valuation platform available on the market.
                            <div className="d-block d-sm-none">
                                <Link to="/posts/1712680200000.6118/" className="btn btn-primary btn-sm">LEARN MORE</Link>
                            </div>
                            </p>
                            <div className="float-end text-center d-none d-sm-block">
                                <img src={interimLogo} width="169" height="56" />
                                <br/>
                                <Link to="/posts/1712680200000.6118/" className="btn btn-primary btn-sm">LEARN MORE</Link>
                            </div>
                        </div>
                    </div>
                </div>
                {/* END BANNER */}
            <section id="topbar" className="d-flex align-items-center">
                <div className="container d-flex justify-content-center justify-content-md-between">
                    <div className="contact-info d-flex align-items-center">
                        <i className="bi bi-envelope d-flex align-items-center"><a href="mailto:info@level1analytics.com">info@level1analytics.com</a></i>
                        <i className="bi bi-phone d-flex align-items-center ms-4"><span>+1 954-483-3424</span></i>
                    </div>
                    <div className="social-links d-none d-md-flex align-items-center">
                        <a href="https://twitter.com/Level1Analytics" className="twitter" target="_blank" rel="noreferrer"><i className="bi bi-twitter"></i></a>
                        <a href="https://www.linkedin.com/company/level1analytics" target="_blank" rel="noreferrer" className="linkedin"><i className="bi bi-linkedin"></i></a>
                    </div>
                </div>
            </section> 
            <header id="header" className="d-flex align-items-center" ref={headerRef}>
                <div className="container d-flex align-items-center justify-content-between">
                    <h1 className="logo">
                        <a href="#home"><img src={l1logo} width="207" height="58" /></a>
                    </h1>
                    
                    <nav id="navbar" className="navbar" ref={navBarRef}>
                        <ul>
                            <li><a className="nav-link scrollto" href="#whatwedo">What We Do</a></li>
                            <li className="nav-link scrollto dropdown"><a href="#"><span>Products &amp; Services</span> <i className="bi bi-chevron-down"></i></a>
                                <ul>
                                    <li><a className="dropdown-navitem nav-link scrollto" href="#products">Products</a></li>
                                    <li><a className="dropdown-navitem nav-link scrollto" href="#services">Services</a></li>
                                    <li><a className="dropdown-navitem nav-link scrollto" href="#blog">Market Overview</a></li>
                                    <li><a className="dropdown-navitem nav-link scrollTo" href="#benefits">The Benefits</a></li>
                                </ul>
                            </li>
                            <li><a className="nav-link scrollto" href="#about">About</a></li>
                            <li><a className="nav-link scrollto" href="#contact">Contact</a></li>
                            {/* <li><a className="nav-link" href="https://apps.level1analytics.com/level1analytics/login.aspx">Login</a></li> */}
                            <li><a className="nav-link" data-bs-toggle="modal" data-bs-target="#modal_appLogin" href="#">Login</a></li>

                            

                            

                            {/* <li><a className="nav-link" href="#" onClick={() => props.showContactModal()}>Contact</a></li> */}

                            {/*
                            <li className="dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="loginDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> <i className="bx bx-user-circle mr-1"></i>&nbsp; <span>Log in</span></a>
                                <div className="dropdown-menu dropdown-menu-end shadow" aria-labelledby="loginDropdown">
                                    <div className="row">
                                        <div className="container-fluid">
                                            <form className="login-dropdown p-3">
                                                <div className="form-group">
                                                    <label className="">Username</label>
                                                    <input className="form-control" name="username" id="username" type="text" />
                                                </div>
                                                <div className="form-group">
                                                    <label className="">Password</label>
                                                    <input className="form-control" name="password" id="password" type="password" />
                                                    <br className="" />
                                                </div>
                                                <button type="submit" id="btnLogin" className="btn btn-primary">Login</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            */}
                        </ul>

                        <i className="bi bi-list mobile-nav-toggle" ref={mobileNavToggleRef}></i>
                    </nav>
                </div>
            </header>
        </>
    );
}

export default Topnav;